import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({
  standalone: true,
  name: 'cleanchars'
})
export class CleanCharsPipe implements PipeTransform {


 transform(value: string, args?: any): any {
    value=value.replaceAll(" ","_");
    return value === undefined ? '' : value.replaceAll(/[.*+?^${}()|[\]\\]/g, '').toUpperCase();
  }
}